/**
 * Valida e normaliza URL de vídeo chamada (apenas http/https com host).
 * @returns {string|null} href normalizado ou null se inválido
 */
export function parseSafeVideoCallUrl(raw) {
  const url = typeof raw === 'string' ? raw.trim() : ''
  if (!url) {
    return null
  }

  let parsed
  try {
    parsed = new URL(url)
  } catch {
    return null
  }

  if (!['http:', 'https:'].includes(parsed.protocol)) {
    return null
  }

  if (!parsed.hostname) {
    return null
  }

  return parsed.href
}
